import React from "react";

/**
 * The Agent Wrapper component.
 * @param {React.ReactNode} children - The content being wrapped.
 * @param {string} className - Any additional classes to style the wrapper.
 * @param {string} title - An optional title for the wrapper.
 * @param {string} backgroundColor - A different background color for the surrounding div.
 * @returns A reusable wrapper for the agent page containers.
 */
const AgentWrapper = ({ children, title, className, backgroundColor }) => {
    return (
        <div style={{ backgroundColor: backgroundColor }}>
            <div
                className={`container-lg mt-3 ${className}`}
                style={{ maxWidth: "950px" }}
            >
                {title && (
                    <h2
                        className="border-bottom mb-2 h4"
                        style={{ borderColor: "var(--bs-gray-200)" }}
                    >
                        {title}
                    </h2>
                )}
                {children}
            </div>
        </div>
    );
};

export default AgentWrapper;
